// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface TextUndoIconSignature {
  Element: SVGSVGElement;
}

export const TextUndoIcon: TOC<TextUndoIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M13 2C8.515 2 4.711 4.969 3.447 9.042L1.866 6.305L0.134003 7.305L3.634 13.367L9.697 9.867L8.697 8.134L5.229 10.136C6.071 6.623 9.231 4 13 4C17.411 4 21 7.589 21 12C21 16.411 17.411 20 13 20V22C18.514 22 23 17.515 23 12C23 6.486 18.514 2 13 2Z"/>
</svg>
</template>;